/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Material Dashboard 2 React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that has other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
// @mui icons
import Icon from "@mui/material/Icon";
import Logout from "pages/logout";
import AnticipateHorizonScan from "pages/Anticipate/AnticipateHorizonScan";
import AnticipateEmergingRisk from "pages/Anticipate/AnticipateEmergingRisk";
import ProtectDashboard from "pages/ProtectDashboard/ProtectDashboard";
import DashboardPage from "layouts/dashboard/components/DashboardPage";

import Profile from "pages/Profile";
import { ReactComponent as HomeIcon } from "./assets/images/icons/projectIcons/home_black_24dp.svg";
import { ReactComponent as ProtectIcon } from "./assets/images/icons/projectIcons/speed_black_24dp.svg";
import { ReactComponent as AnticipateIcon } from "./assets/images/icons/projectIcons/pie_chart_outline_black_24dp.svg";
import { ReactComponent as ConnectIcon } from "./assets/images/icons/projectIcons/hub_black_24dp.svg";
import { ReactComponent as CheckIcon } from "./assets/images/icons/projectIcons/health_and_safety_black_24dp.svg";

const routes = [
  {
    type: "collapse",
    name: "Home",
    key: "dashboard",
    // icon: <Icon fontSize="small">home</Icon>,
    icon: <HomeIcon />,
    route: "/home",
    noCollapse: true,
    component: <DashboardPage />,
  },
  // { type: "divider", key: "divider-1" },
  {
    type: "collapse",
    name: "Protect",
    key: "protect",
    route: "/overview",
    // icon: <Icon fontSize="small">speed</Icon>,
    icon: <ProtectIcon />,
    noCollapse: true,
    component: <ProtectDashboard />,
  },
  // { type: "divider", key: "divider-2" },
  {
    type: "collapse",
    name: "Anticipate",
    key: "anticipate",
    route: "/dashboard",
    // icon: <Icon fontSize="small">pie</Icon>,
    icon: <AnticipateIcon />,
    collapse: [
      {
        name: "Emerging Risks",
        key: "emergingRisks",
        route: "/anticipate/EmergingRisks",
        component: <AnticipateEmergingRisk />,
      },
      {
        name: "Horizon Scan",
        key: "horizonScan",
        route: "/anticipate/HorizonScan",
        component: <AnticipateHorizonScan />,
      },
    ],
  },
  // { type: "divider", key: "divider-3" },
  {
    type: "collapse",
    name: "Connect",
    key: "connect",
    route: "/dashboard",
    // icon: <Icon fontSize="small">hub</Icon>,
    icon: <ConnectIcon />,
  },
  // { type: "divider", key: "divider-4" },
  {
    type: "collapse",
    name: "Check",
    key: "check",
    route: "/check",
    // icon: <Icon fontSize="small">shield</Icon>,
    icon: <CheckIcon />,
    noCollapse: true,
    component: <Dashboard />,
  },
  // { type: "divider", key: "divider-5" },
  {
    type: "collapse",
    name: "Settings",
    key: "settings",
    route: "/dashboard",
    icon: <Icon fontSize="small">settings</Icon>,
  },
  // { type: "divider", key: "divider-6" },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    icon: <Icon fontSize="small">dashboard</Icon>,
    collapse: [
      {
        name: "Setting",
        key: "setting",
        route: "/dashboard/Profile",
        component: <Profile />,
      },
      {
        name: "Logout",
        key: "logout",
        route: "/authentication/logout",
        component: <Logout />,
      },
    ],
  },
];

export default routes;
